<template>
  <div class="p-b-5">
    <v-table
      :data="formattedReferences"
      :current-page.sync="currentPage"
      :page-size="10"
      :hide-sort-icons="true"
      class="table_beauty"
      @totalPagesChanged="totalPages = $event"
    >
      <thead slot="head">
        <tr>
          <v-th
            v-t="'LABEL_TYPE'"
            :custom-sort="typeSort"
            default-sort="asc"
          />
          <v-th
            v-t="'LABEL_NAME'"
            sort-key="name"
          />
          <th v-t="'LABEL_ID'" />
        </tr>
      </thead>
      <tbody
        slot="body"
        slot-scope="{ displayData }"
      >
        <tr
          v-for="row in displayData"
          :key="row.id"
        >
          <td>{{ row.type }}</td>
          <td>
            <a
              rel="noopener"
              target="_blank"
              :href="row.link"
              class="table-ellipsis__name linked-name"
            >
              <span :title="row.name">
                {{ row.name }}
              </span>
            </a>
          </td>
          <td>
            {{ row.id }}
          </td>
        </tr>
      </tbody>
    </v-table>
    <div class="pagination-min">
      <div class="text-center p-7">
        <smart-pagination
          v-if="shouldShowTable"
          :current-page.sync="currentPage"
          :total-pages="totalPages"
        />
      </div>
    </div>
    
    <div
      v-if="getPublisherReferencesStatus.status === 'pending'"
      class="well well-sm text-center"
    >
      <Loader />
      <span v-t="'REFERENCES_LOADING'" />
    </div>
    <div
      v-if="getPublisherReferencesStatus.status === 'success' && !hasReferences"
      v-t="'REFERENCES_EMPTY'"
      class="well well-sm text-center"
    />
  </div>
</template>

<script>
import messages from '../locales';
import sharedMessages from '@/core/locales';
import { mapActions, mapGetters, mapState } from 'vuex';
import Loader from '@/core/components/Loader';

export default {
  name: 'PublisherReferences',
  components: {
    Loader
  },
  props: {
    pubId: {
      type: String,
      default() {
        return '';
      },
    },
  },
  data() {
    return {
      currentPage: 1,
      totalPages: 0,
    };
  },
  computed: {
    ...mapState('publisher', ['publisherReferences']),
    ...mapGetters('publisher', ['getPublisherReferencesStatus']),
    shouldShowTable() {
      return this.getPublisherReferencesStatus.status === 'success' && this.hasReferences;
    },
    hasReferences() {
      return this.publisherReferences?.hasReferences || false;
    },
    formattedReferences() {
      if (!this.publisherReferences) {
        return [];
      }

      const campaignReferences = (this.publisherReferences.campaigns || []).map(campaign => ({
        type: 'Campaign',
        name: campaign.campaignName,
        id: campaign.campaignId,
        link: `#/dashboard/campaign/${campaign.campaignId}`,
      }));

      const numberReferences = (this.publisherReferences.numbers || []).map(number => ({
        type: 'Number',
        name: number.numberName,
        id: number.numberId,
        link: `#/dashboard/numbers/edit/${number.numberId}`,
      }));

      return [...campaignReferences, ...numberReferences];
    }
  },
  created() {
    this.getPublisherReferences({ pubId: this.pubId });
  },
  methods: {
    ...mapActions('publisher', ['getPublisherReferences']),
    typeSort(a, b) {
      if (a.type === b.type) {
        if (a.name === b.name) {
          return 0;
        }
        if (a.name > b.name) {
          return 1;
        }
        return -1;
      }
      if (a.type > b.type) {
        return 1;
      }
      return -1;
    },
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  }
};
</script>